import { render, staticRenderFns } from "./MachineDetails.vue?vue&type=template&id=c5254fa6&"
import script from "./MachineDetails.vue?vue&type=script&lang=js&"
export * from "./MachineDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports